"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _downshift = require("downshift");
var _underscore = _interopRequireDefault(require("underscore"));
var _create_async_filter = _interopRequireDefault(require("./utils/create_async_filter"));
var _use_async_dropdown_filter = _interopRequireDefault(require("./use_async_dropdown_filter"));
var _use_row_virtualizer = _interopRequireDefault(require("./use_row_virtualizer"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var itemToString = function itemToString(item) {
  return (item === null || item === void 0 ? void 0 : item.label) || '';
};
// Downshift expects keys not to be undefined if they are set
function extractMultipleSelectionOptions(options) {
  var multipleSelectionOptions = {
    initialSelectedItems: options.initialSelectedItems || []
  };
  if (options.initialSelectedItems) {
    multipleSelectionOptions.initialSelectedItems = options.initialSelectedItems;
  }
  if (options.onSelectedItemsChange) {
    // @ts-expect-error Downshift expects this property to be of type UseMultipleSelectionStateChange<Item> which requires a 'type' property.
    // TODO: refactor o wrap onSelectedItemsChange in a function that takes an object with a type property in addition to selectedItems
    multipleSelectionOptions.onSelectedItemsChange = options.onSelectedItemsChange;
  }
  if (options.selectedItems) {
    multipleSelectionOptions.selectedItems = options.selectedItems;
  }
  return multipleSelectionOptions;
}
var useMultiDropdown = function useMultiDropdown(options) {
  var itemsFetcher = _underscore["default"].isFunction(options.items) ? options.items : (0, _create_async_filter["default"])(options.items);
  var useMultipleSelectionResult = (0, _downshift.useMultipleSelection)(extractMultipleSelectionOptions(options));
  var previouslyCreatedItems = useMultipleSelectionResult.selectedItems.filter(function (i) {
    return i.userCreated;
  });
  var _useAsyncDropdownFilt = (0, _use_async_dropdown_filter["default"])(itemsFetcher, {
      creatable: options.creatable,
      previouslyCreatedItems: previouslyCreatedItems
    }),
    _useAsyncDropdownFilt2 = (0, _slicedToArray2["default"])(_useAsyncDropdownFilt, 3),
    items = _useAsyncDropdownFilt2[0],
    loadingStatus = _useAsyncDropdownFilt2[1],
    onSearchTermChange = _useAsyncDropdownFilt2[2];
  var selectableItems = items.filter(function (item) {
    return !useMultipleSelectionResult.selectedItems.map(function (i) {
      return i.value;
    }).includes(item.value);
  });
  var _useRowVirtualizer = (0, _use_row_virtualizer["default"])(selectableItems),
    rowVirtualizer = _useRowVirtualizer.rowVirtualizer,
    parentRef = _useRowVirtualizer.parentRef;
  var useComboboxResult = (0, _downshift.useCombobox)({
    defaultHighlightedIndex: 0,
    // after selection, highlight the first item.
    selectedItem: null,
    items: selectableItems,
    itemToString: itemToString,
    stateReducer: function stateReducer(state, actionAndChanges) {
      var _changes$selectedItem;
      var changes = actionAndChanges.changes,
        type = actionAndChanges.type;
      if (changes !== null && changes !== void 0 && (_changes$selectedItem = changes.selectedItem) !== null && _changes$selectedItem !== void 0 && _changes$selectedItem.disabled) {
        return state;
      }
      switch (type) {
        case _downshift.useCombobox.stateChangeTypes.InputBlur:
          return _objectSpread(_objectSpread({}, changes), {}, {
            inputValue: ''
          });
        case _downshift.useCombobox.stateChangeTypes.InputKeyDownEnter:
        case _downshift.useCombobox.stateChangeTypes.ItemClick:
          return _objectSpread(_objectSpread({}, changes), {}, {
            isOpen: true // keep the menu open after selection.
          });
      }

      return changes;
    },
    onStateChange: function onStateChange(_ref) {
      var inputValue = _ref.inputValue,
        type = _ref.type,
        selectedItem = _ref.selectedItem;
      switch (type) {
        case _downshift.useCombobox.stateChangeTypes.InputChange:
          onSearchTermChange(inputValue);
          break;
        case _downshift.useCombobox.stateChangeTypes.InputKeyDownEnter:
        case _downshift.useCombobox.stateChangeTypes.ItemClick:
          if (selectedItem) {
            onSearchTermChange('');
            useMultipleSelectionResult.addSelectedItem(selectedItem);
          } else {
            if (_underscore["default"].isEmpty(items)) {
              onSearchTermChange('');
            }
          }
          break;
        default:
          break;
      }
    },
    onHighlightedIndexChange: function onHighlightedIndexChange(_ref2) {
      var highlightedIndex = _ref2.highlightedIndex,
        type = _ref2.type;
      if (type !== _downshift.useCombobox.stateChangeTypes.MenuMouseLeave) {
        if (highlightedIndex !== undefined) {
          rowVirtualizer.scrollToIndex(highlightedIndex);
        }
      }
    }
  });
  return _objectSpread(_objectSpread(_objectSpread({}, useComboboxResult), useMultipleSelectionResult), {}, {
    items: selectableItems,
    loadingStatus: loadingStatus,
    loadInitialOptions: function loadInitialOptions() {
      onSearchTermChange('');
    },
    rowVirtualizer: rowVirtualizer,
    parentRef: parentRef
  });
};
var _default = useMultiDropdown;
exports["default"] = _default;